// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__6POeH","fadeIn":"style_fadeIn__nkwUi","warp":"style_warp__OK6BX"};